export default __webpack_public_path__ + "static/media/updating-white.08342ed3.svg";